import styled from 'styled-components'
import { Button } from '~/shared/ui/Buttons'

export const RemoveAllButton = styled(Button)`
  position: absolute;
  top: 7px;
  right: 6px;
  font-size: 14px;
  z-index: 1;
  --box-shadow: none;
`

export const FieldWrapper = styled.div`
  position: relative;
  margin-bottom: 60px;

  ion-input,
  ion-input::part(native) {
    --padding-end: 140px;
  }
`
